const sizes = {
  constrainPage: "1400px",
};

export default sizes;
